document.addEventListener("DOMContentLoaded", (event) => {
  // Ensure GSAP is loaded
  if (typeof gsap !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);

    // Fade Up Animation
    const fadeUpElements = document.querySelectorAll('[data-gsap="fade-up"]');
    fadeUpElements.forEach((el) => {
      gsap.fromTo(el, 
        { y: 50, opacity: 0 },
        { 
          y: 0, 
          opacity: 1, 
          duration: 1, 
          ease: "power3.out",
          scrollTrigger: {
            trigger: el,
            start: "top 85%",
            toggleActions: "play none none reverse"
          }
        }
      );
    });

    // Zoom In Animation
    const zoomInElements = document.querySelectorAll('[data-gsap="zoom-in"]');
    zoomInElements.forEach((el) => {
      gsap.fromTo(el, 
        { scale: 0.8, opacity: 0 },
        { 
          scale: 1, 
          opacity: 1, 
          duration: 1.2, 
          ease: "back.out(1.7)",
          scrollTrigger: {
            trigger: el,
            start: "top 80%",
            toggleActions: "play none none reverse"
          }
        }
      );
    });

    // Stagger Fade Up (For Lists/Cards)
    const staggerContainers = document.querySelectorAll('[data-gsap-stagger="container"]');
    staggerContainers.forEach((container) => {
      const items = container.querySelectorAll('[data-gsap-stagger="item"]');
      if (items.length > 0) {
        gsap.fromTo(items, 
          { y: 40, opacity: 0 },
          { 
            y: 0, 
            opacity: 1, 
            duration: 0.8, 
            stagger: 0.15,
            ease: "power2.out",
            scrollTrigger: {
              trigger: container,
              start: "top 80%",
              toggleActions: "play none none reverse"
            }
          }
        );
      }
    });

    // Parallax effect
    const parallaxElements = document.querySelectorAll('[data-gsap="parallax"]');
    parallaxElements.forEach((el) => {
      gsap.fromTo(el, 
        { y: -30 },
        { 
          y: 30, 
          ease: "none",
          scrollTrigger: {
            trigger: el.parentElement,
            start: "top bottom",
            end: "bottom top",
            scrub: true
          }
        }
      );
    });
    
    // Slide In Right
    const slideInRightElements = document.querySelectorAll('[data-gsap="slide-in-right"]');
    slideInRightElements.forEach((el) => {
      gsap.fromTo(el, 
        { x: 50, opacity: 0 },
        { 
          x: 0, 
          opacity: 1, 
          duration: 1, 
          ease: "power3.out",
          scrollTrigger: {
            trigger: el,
            start: "top 85%",
            toggleActions: "play none none reverse"
          }
        }
      );
    });

    // Slide In Left
    const slideInLeftElements = document.querySelectorAll('[data-gsap="slide-in-left"]');
    slideInLeftElements.forEach((el) => {
      gsap.fromTo(el, 
        { x: -50, opacity: 0 },
        { 
          x: 0, 
          opacity: 1, 
          duration: 1, 
          ease: "power3.out",
          scrollTrigger: {
            trigger: el,
            start: "top 85%",
            toggleActions: "play none none reverse"
          }
        }
      );
    });

    // Reveal Mask Animation (Text or Image reveal)
    const revealElements = document.querySelectorAll('[data-gsap="reveal"]');
    revealElements.forEach((el) => {
      gsap.fromTo(el, 
        { clipPath: "inset(0 100% 0 0)" },
        { 
          clipPath: "inset(0 0% 0 0)", 
          duration: 1.5, 
          ease: "power3.inOut",
          scrollTrigger: {
            trigger: el,
            start: "top 80%",
            toggleActions: "play none none reverse"
          }
        }
      );
    });
  }
});
